const META_KEYS = ['opening', 'closing', 'last', 'number'];
const ZERO_THRESHOLD = 0.005;

const toFiniteNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

export const hasNonZeroBalance = (node) => {
  if (!node) return false;

  return (
    Math.abs(toFiniteNumber(node.opening)) > ZERO_THRESHOLD ||
    Math.abs(toFiniteNumber(node.closing)) > ZERO_THRESHOLD
  );
};

const pruneNode = (node) => {
  if (!node) return false;

  Object.keys(node).forEach((key) => {
    if (META_KEYS.includes(key)) return;
    if (!pruneNode(node[key])) delete node[key];
  });

  const hasVisibleChildren = Object.keys(node).some((key) => !META_KEYS.includes(key));
  return hasVisibleChildren || hasNonZeroBalance(node);
};

export const pruneZeroBalanceLines = (collapsableData, totalKey) => {
  if (!collapsableData) return collapsableData;

  Object.keys(collapsableData).forEach((key) => {
    if (key === totalKey) return;
    if (!pruneNode(collapsableData[key])) delete collapsableData[key];
  });

  return collapsableData;
};
